﻿import config from "../config"
const baseUrl = config.base_url + "lz_period/"
export default {
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    }
    ,
    allList: {
        url: baseUrl + "allList",
        type: "post",
    },
    listByNsTypeId: {
        url: baseUrl + "listByNsTypeId",
        type: "get",
    }
}

